module.exports = __webpack_public_path__ + "img/1.3e0c08f9.jpg";